// src/pages/Dashboard.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./dashboard.css";
import logoImg from "./img/RootServices.jpeg";

const cardList = [
  { label: "Booking Orders", path: "/orders" },
  { label: "Employee Progress", path: "/employees" },
  { label: "Add Services", path: "/add-services" },
  { label: "Customer List", path: "/customers",adminOnly: true },
  { label: "Add Image", path: "/feedback"  },
  { label: "Offer Page", path: "/offers"  },
  { label: "Add Admin", path: "/AddAdmin", adminOnly: true }, // mark admin/founder only
];

const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const raw = localStorage.getItem("owner_user");
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        setUser(parsed);
      } catch (e) {
        setUser({ username: raw });
      }
    }
  }, []);

  const handleLogout = async () => {
    const admin_id = user?.admin_id;
    if (admin_id) {
      try {
        await fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/admin_logout.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ admin_id }),
        });
      } catch (err) {
        console.error("Logout API error:", err);
      }
    }

    localStorage.removeItem("owner_logged_in");
    localStorage.removeItem("owner_user");
    navigate("/admin-login");
  };

  // Filter cards: only show "Add Admin" if user is founder/admin (e.g., admin_id === 2)
  const visibleCards = cardList.filter(card => {
    if (card.adminOnly) {
      return user?.admin_id === 2; // only founder/admin
    }
    return true;
  });

  return (
    <div className="dashboard-container-light">
      <img src={logoImg} alt="Watermark Logo" className="dashboard-logo-bg-light" />

      <div className="dashboard-header-light" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <img src={logoImg} alt="Root Services" className="dashboard-logo-top" />
          <div>
            <h1 className="dashboard-title-light" style={{ margin: 0 }}>Root Services Dashboard</h1>
            {user && (
              <div style={{ fontSize: 14, marginTop: 4, opacity: 0.9 }}>
                <strong>{user.username}</strong> <br />
                {(user.city || user.state) && `${user.city || ""}${user.city && user.state ? ", " : ""}${user.state || ""}`}
              </div>
            )}
          </div>
        </div>

        <button onClick={handleLogout} style={{ padding: "8px 12px", cursor: "pointer" }}>Logout</button>
      </div>

      <div className="dashboard-grid-light">
        {visibleCards.map((card, index) => (
          <div
            key={index}
            className="dashboard-card-light"
            onClick={() => navigate(card.path)}
          >
            {card.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
